import { CloseRounded } from "@mui/icons-material";
import { Divider, Grid, Grow, IconButton, Paper } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { action, API, controller } from "../../../../api/api";
import { lsGet } from "../../../../hooks/Method";
import { Input } from "../../../../controls";
import { no_img } from "../../../../assets";
import { AppContext } from "../../../../App";

const Users = ({ handleClose, setStep, setValues, setSnackbar }) => {
  const activeReg = lsGet("activeReg");
  const { authUser } = useContext(AppContext);
  const [isOutletUsers, setIsOutletUsers] = useState([]);
  const [users, setUsers] = useState([]);
  const [fltUsers, setFltUsers] = useState([]);

  const GetUsersByOrg = () => {
    API(controller.User + action.GetAllByOrg).get((res) => {
      if (res && res.status === 200) {
        setUsers([...res.result]);
        setFltUsers([...res.result]);
        setIsOutletUsers(false);
      }
    });
  };

  useEffect(() => {
    var location = document.location.pathname;

    const onComplete = (res) => {
      if (res && res.status === 200) {
        if (res.result.length > 0) {
          setUsers([...res.result]);
          setFltUsers([...res.result]);
          setIsOutletUsers(true);
        } else GetUsersByOrg();
      }
    };

    if (activeReg && activeReg.outletId && location.includes("/sell")) {
      API(controller.User + action.GetAllByOutlet).getById(
        activeReg.outletId,
        onComplete
      );
    } else GetUsersByOrg();

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filter = (e) => {
    var searchVal = e.target.value;
    setFltUsers([
      ...users.filter(
        (j) =>
          j.id.toString().includes(searchVal) ||
          (j.firstName + " " + j.lastName).includes(searchVal) ||
          j.email.includes(searchVal)
      ),
    ]);
  };

  const handleSwitch = (val) => {
    if (val.id !== authUser.id && val && val.email) {
      setValues((j) => ({
        ...j,
        id: val.id,
        email: val.email,
        photo: val.photo,
        name: val.firstName + " " + val.lastName,
      }));
      setStep(2);
    } else if (val && val.email) {
      setSnackbar({
        show: true,
        type: "info",
        msg: "You're already logged in.",
      });
      handleClose();
    }
  };

  return (
    <Grow in={true}>
      <Paper>
        <div className="p-[10px] pb-[5px] gap-5 flex items-center justify-between">
          <div>
            <span className="text-[20px] border-left font-medium text-gray-500">
              Switch to a different user
            </span>
          </div>
          <div>
            <IconButton onClick={handleClose} size="small">
              <CloseRounded />
            </IconButton>
          </div>
        </div>
        <Divider />
        <div className="p-[15px]">
          <Grid container spacing={2}>
            {/* Search */}
            <Grid item xs={12}>
              <div className="mt-[5px]" />
              <Input
                placeholder="Search by id, name or email"
                onChange={filter}
              />
            </Grid>
            <Grid item xs={12}>
              <div className="mt-[20px]" />
              <span className="border-left text-[18px] font-medium text-gray-500">
                All users {isOutletUsers && " in this outlet"}
              </span>
            </Grid>
            {/* Body */}
            {fltUsers.length > 0 ? (
              fltUsers.map((user, ind) => (
                <Grid
                  key={ind}
                  item
                  xs={12}
                  md={6}
                  onClick={() => handleSwitch(user)}
                >
                  <div className="flex items-center gap-3 border p-[10px] rounded-[15px] cursor-pointer hover:bg-slate-100 hover:shadow-md transition">
                    <div>
                      <img
                        alt="Natacha"
                        src={user.photo || no_img}
                        className="!h-[80px] !w-[80px] object-cover bg-slate-100 rounded-[10px] shadow"
                      />
                    </div>
                    <div className="flex items-center">
                      <div className="grid gap-1 pr-[10px]">
                        <span className="text-[20px] font-medium text-gray-500">
                          {user.firstName + " " + user.lastName} ({user.id})
                        </span>
                        <span className="text-[14px] font-medium text-gray-500">
                          {user.email}
                        </span>
                      </div>
                    </div>
                  </div>
                </Grid>
              ))
            ) : (
              <div className="p-[20px]">
                <span className="text-[20px] text-gray-500 font-medium">
                  No user found
                </span>
              </div>
            )}
          </Grid>
        </div>
      </Paper>
    </Grow>
  );
};

export default Users;
